export type HTTPMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

type ApiOptions = {
    method: HTTPMethod
    headers?: HeadersInit
    body?: BodyInit
    credentials?: 'omit' | 'same-origin' | 'include'
}

const getApiOptions = ({ method, headers, body }: ApiOptions): RequestInit => {
    const options: RequestInit = {
        method,
        credentials: 'include',
    }

    if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
        options.headers = {
            ...options.headers,
            'Content-Type': 'application/json',
        }
    }

    if (headers) {
        options.headers = { ...options.headers, ...headers as Record<string, string> }
    }

    if (body) {
        options.body = body
    }

    return options
}

export default getApiOptions
